import {COUNTRY_CODES} from './countryCodes';

const DRIVING_LICENSES = {
  drivingLicense: 'DL',
  drivingLicenseES: 'ES_C',
  drivingLicenseCZ: 'CZ_DL',
  drivingLicenseAT: 'AT_DL',
  drivingLicenseDE: 'DE_DL',
  drivingLicenseGR: 'GR_DL',
  drivingLicenseGB: 'GB_DL',
  drivingLicenseIT: 'IT_PATEN',
  drivingLicenseRO: 'RO_DL',
  drivingLicenseUS: 'US_DL',
  drivingLicenseCA: 'CA_DL',
  drivingLicenseHR: 'HR_DL',
  drivingLicenseFR: 'FR_DL',
  drivingLicenseHU: 'HU_DL',
  drivingLicenseNL: 'NL_DL',
  drivingLicenseCH: 'CH_DL',
  drivingLicenseJP: 'JP_DL',
  drivingLicenseSI: 'SL_V',
};

const IDENTITY_CARDS = {
  identityCard: 'I',
  identityCardES: 'ES_I',
  identityCardIT: 'IT_IDELE',
  identityCardPaperIT: 'IT_IDENT',
  identityCardPT: 'PT_B',
  identityCardCZ: 'CZ_ID',
  identityCardAT: 'AT_ID',
  identityCardAE: 'AE_ID',
  identityCardGccAE: 'AE_ID_GCC',
  identityCardDE: 'DE_ID',
  identityCardGR: 'GR_ID',
  identityCardGB: 'GB_ID',
  identityCardHR: 'HR_ID',
  identityCardCO: 'CO_I',
  identityCardMinorCO: 'CO_IM',
  identityCardOldCO: 'CO_ID_OLD',
  identityCardForeignCO: 'CO_EID',
  identityCardUS: 'US_ID',
  identityCardRO: 'RO_ID',
  identityCardFR: 'FR_ID',
  identityCardPaperFR: 'FR_IDENT',
  identityCardBE: 'BE_ID',
  identityCardHU: 'HU_ID',
  identityCardNL: 'NL_ID',
  identityCardCH: 'CH_ID',
  identityCardTH: 'TH_ID',
  identityCardJP: 'JP_ID',
  identityCardCA: 'CA_ID',
  identityCardBG: 'BG_ID',
  identityCardSI: 'SL_I',
};

const PASSPORTS = {
  passport: 'P',
  passportPT: 'PT_P',
  passportIT: 'IT_PASOR',
  passportCZ: 'CZ_P',
  passportAT: 'AT_P',
  passportDE: 'DE_P',
  passportGR: 'GR_P',
  passportGB: 'GB_P',
  passportES: 'ES_P',
  passportCO: 'CO_P',
  passportRO: 'RO_P',
  passportHR: 'HR_P',
  passportAE: 'AE_P',
  passportFR: 'FR_P',
  passportBE: 'BE_P',
  passportHU: 'HU_P',
  passportNL: 'NL_P',
  passportCH: 'CH_P',
  passportTH: 'TH_P',
  passportUS: 'US_P',
  passportJP: 'JP_P',
  passportCA: 'CA_P',
  passportBG: 'BG_P',
  passportSI: 'SL_P',
  armyIdGR: 'GR_ARMY_ID',
};

const NO_EQUIVALENT_DOC_TYPE = 'None';

const DNI_DOCUMENTS = {
  dniES: 'ES_D',
  dniOldGreek: 'GR_ID_OLD',
};

const RESIDENCE_PERMITS = {
  dubaiResidencePermit: 'AE_RP',
  spanishResidencePermitEU: 'ES_N',
  spanishForeignerResidencePermitNIE: 'ES_X',
  columbianResidencePermit: 'CO_FID',
};

const DOCUMENTS_TYPES = {
  diplomaticPassportIT: 'IT_PASDI',
  diplomaticIdentityIT: 'IT_CIDIP',
  diplomaticIdCO: 'CO_DIP',
  servicePassportIT: 'IT_PASSE',
  othersDocumentsPT: 'PT_O',
  othersDocumentsAT: 'AT_O',
  workPermitGR: 'GR_WORK_PERMIT',
  foreignDocumentCO: 'CO_FD',
  identityCertificateIT: 'IT_CERID',
  civilRegistrationCO: 'CO_CR',
  temporaryProtectionCO: 'CO_TEM',
  ...DNI_DOCUMENTS,
  ...RESIDENCE_PERMITS,
  ...PASSPORTS,
  ...IDENTITY_CARDS,
  ...DRIVING_LICENSES,
};

// Nationalities that get the GCC identity card instead of the local one in the UAE.
const GCC_COUNTRY_CODES = ['BH', 'KW', 'OM', 'QA', 'SA'];

const IDENTITY_CARDS_OCR_CODES = new Set([
  ...Object.values(IDENTITY_CARDS),
  ...Object.values(DNI_DOCUMENTS),
  'ID',
  'CI',
  'C',
  'I',
  'IA', // Argentinian DNI
  'CA', // Norway ID
  'IL', // UAE ID
  'II', // Romanian ID
  'IO', // French or croatian Identity Card
  'FD', // French national Identity Card
  'CD', // Spanish DNI
  'JF', // Spanish DNI
]);

const RESIDENCE_PERMITS_OCR_CODES = new Set([
  ...Object.values(RESIDENCE_PERMITS),
  'IR',
  'IM',
  'IX',
  'AD', // Horvatian Residence Permit
  'AR', // Deutsche Aufenthaltstitel (German Residence Permit)
]);

const DRIVING_LICENSES_OCR_CODES = new Set([...Object.values(DRIVING_LICENSES), 'DL']);

const PASSPORTS_OCR_CODES = new Set([
  ...Object.values(PASSPORTS),
  'P<', // Ordinary passport (legacy MRZ, filler as subtype)
  'PP', // Ordinary passport
  'PE', // Emergency passport or Romanian Passport
  'PD', // Diplomatic passport
  'PO', // Official / service passport or Chinese Passport
  'PR', // Refugee passport
  'PT', // Alien's passport
  'PS', // Stateless person's passport
  'PL', // Laissez-passer
  'PM', // Military passport or Korean Passport
  'PU', // Emergency travel document (single sheet)
  'PA', // Moldovan Passport
  'PV', // Norway Passport
  'PC', // Sudan Passport

  // Codes detected before the MRZ rules above were applied. They don't follow
  // the ICAO scheme ('IP' and 'U' aren't passport classes, 'V0' is a visa one),
  // so they stay commented out until we confirm the OCR really returns them.
  // 'IP', // Irish Passport
  // 'V0', // Chinese Passport
  // 'U', // USA Passport
]);

type CountryDocType = string | ((nationality?: string) => string);

const IDENTITY_CARD_BY_COUNTRY: Record<string, CountryDocType> = {
  [COUNTRY_CODES.spain]: nationality =>
    nationality === COUNTRY_CODES.spain
      ? DOCUMENTS_TYPES.dniES
      : DOCUMENTS_TYPES.identityCardES,
  [COUNTRY_CODES.italy]: DOCUMENTS_TYPES.identityCardIT,
  [COUNTRY_CODES.portugal]: DOCUMENTS_TYPES.identityCardPT,
  [COUNTRY_CODES.colombia]: nationality =>
    nationality === COUNTRY_CODES.colombia
      ? DOCUMENTS_TYPES.identityCardCO
      : DOCUMENTS_TYPES.identityCardForeignCO,
  [COUNTRY_CODES.romania]: DOCUMENTS_TYPES.identityCardRO,
  [COUNTRY_CODES.austria]: DOCUMENTS_TYPES.identityCardAT,
  [COUNTRY_CODES.germany]: DOCUMENTS_TYPES.identityCardDE,
  [COUNTRY_CODES.france]: nationality =>
    nationality === COUNTRY_CODES.france
      ? DOCUMENTS_TYPES.identityCardPaperFR
      : DOCUMENTS_TYPES.identityCardFR,
  [COUNTRY_CODES.croatia]: DOCUMENTS_TYPES.identityCardHR,
  [COUNTRY_CODES.czech]: DOCUMENTS_TYPES.identityCardCZ,
  [COUNTRY_CODES.greece]: DOCUMENTS_TYPES.identityCardGR,
  [COUNTRY_CODES.uk]: DOCUMENTS_TYPES.identityCardGB,
  [COUNTRY_CODES.slovenia]: DOCUMENTS_TYPES.identityCardSI,
  [COUNTRY_CODES.belgium]: DOCUMENTS_TYPES.identityCardBE,
  [COUNTRY_CODES.hungary]: DOCUMENTS_TYPES.identityCardHU,
  [COUNTRY_CODES.netherlands]: DOCUMENTS_TYPES.identityCardNL,
  [COUNTRY_CODES.switzerland]: DOCUMENTS_TYPES.identityCardCH,
  [COUNTRY_CODES.thailand]: DOCUMENTS_TYPES.identityCardTH,
  [COUNTRY_CODES.usa]: DOCUMENTS_TYPES.identityCardUS,
  [COUNTRY_CODES.canada]: DOCUMENTS_TYPES.identityCardCA,
  [COUNTRY_CODES.japan]: DOCUMENTS_TYPES.identityCardJP,
  [COUNTRY_CODES.bulgaria]: DOCUMENTS_TYPES.identityCardBG,
  [COUNTRY_CODES.uae]: nationality => {
    if (nationality === COUNTRY_CODES.uae) {
      return DOCUMENTS_TYPES.identityCardAE;
    }
    return nationality && GCC_COUNTRY_CODES.includes(nationality)
      ? DOCUMENTS_TYPES.identityCardGccAE
      : NO_EQUIVALENT_DOC_TYPE;
  },
};

const RESIDENCE_PERMIT_BY_COUNTRY: Record<string, CountryDocType> = {
  [COUNTRY_CODES.spain]: DOCUMENTS_TYPES.spanishResidencePermitEU,
  [COUNTRY_CODES.italy]: DOCUMENTS_TYPES.identityCardIT,
  [COUNTRY_CODES.portugal]: DOCUMENTS_TYPES.othersDocumentsPT,
  [COUNTRY_CODES.austria]: DOCUMENTS_TYPES.othersDocumentsAT,
  [COUNTRY_CODES.colombia]: DOCUMENTS_TYPES.columbianResidencePermit,
  [COUNTRY_CODES.uae]: DOCUMENTS_TYPES.dubaiResidencePermit,
  [COUNTRY_CODES.croatia]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.poland]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.czech]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.greece]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.uk]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.slovenia]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.belgium]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.france]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.germany]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.hungary]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.netherlands]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.switzerland]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.thailand]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.romania]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.usa]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.canada]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.japan]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.bulgaria]: NO_EQUIVALENT_DOC_TYPE,
};

const DRIVING_LICENSE_BY_COUNTRY: Record<string, CountryDocType> = {
  [COUNTRY_CODES.romania]: DOCUMENTS_TYPES.drivingLicenseRO,
  [COUNTRY_CODES.usa]: DOCUMENTS_TYPES.drivingLicenseUS,
  [COUNTRY_CODES.canada]: DOCUMENTS_TYPES.drivingLicenseCA,
  [COUNTRY_CODES.austria]: DOCUMENTS_TYPES.drivingLicenseAT,
  [COUNTRY_CODES.germany]: DOCUMENTS_TYPES.drivingLicenseDE,
  [COUNTRY_CODES.croatia]: DOCUMENTS_TYPES.drivingLicenseHR,
  [COUNTRY_CODES.italy]: DOCUMENTS_TYPES.drivingLicenseIT,
  [COUNTRY_CODES.greece]: DOCUMENTS_TYPES.drivingLicenseGR,
  [COUNTRY_CODES.uk]: DOCUMENTS_TYPES.drivingLicenseGB,
  [COUNTRY_CODES.france]: DOCUMENTS_TYPES.drivingLicenseFR,
  [COUNTRY_CODES.hungary]: DOCUMENTS_TYPES.drivingLicenseHU,
  [COUNTRY_CODES.netherlands]: DOCUMENTS_TYPES.drivingLicenseNL,
  [COUNTRY_CODES.switzerland]: DOCUMENTS_TYPES.drivingLicenseCH,
  [COUNTRY_CODES.japan]: DOCUMENTS_TYPES.drivingLicenseJP,
  [COUNTRY_CODES.slovenia]: DOCUMENTS_TYPES.drivingLicenseSI,
  [COUNTRY_CODES.spain]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.portugal]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.colombia]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.czech]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.belgium]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.thailand]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.bulgaria]: NO_EQUIVALENT_DOC_TYPE,
  [COUNTRY_CODES.uae]: NO_EQUIVALENT_DOC_TYPE,
};

const PASSPORT_BY_COUNTRY: Record<string, CountryDocType> = {
  [COUNTRY_CODES.spain]: DOCUMENTS_TYPES.passportES,
  [COUNTRY_CODES.italy]: DOCUMENTS_TYPES.passportIT,
  [COUNTRY_CODES.portugal]: DOCUMENTS_TYPES.passportPT,
  [COUNTRY_CODES.colombia]: DOCUMENTS_TYPES.passportCO,
  [COUNTRY_CODES.romania]: DOCUMENTS_TYPES.passportRO,
  [COUNTRY_CODES.austria]: DOCUMENTS_TYPES.passportAT,
  [COUNTRY_CODES.germany]: DOCUMENTS_TYPES.passportDE,
  [COUNTRY_CODES.croatia]: DOCUMENTS_TYPES.passportHR,
  [COUNTRY_CODES.czech]: DOCUMENTS_TYPES.passportCZ,
  [COUNTRY_CODES.greece]: DOCUMENTS_TYPES.passportGR,
  [COUNTRY_CODES.uk]: DOCUMENTS_TYPES.passportGB,
  [COUNTRY_CODES.slovenia]: DOCUMENTS_TYPES.passportSI,
  [COUNTRY_CODES.belgium]: DOCUMENTS_TYPES.passportBE,
  [COUNTRY_CODES.france]: DOCUMENTS_TYPES.passportFR,
  [COUNTRY_CODES.hungary]: DOCUMENTS_TYPES.passportHU,
  [COUNTRY_CODES.netherlands]: DOCUMENTS_TYPES.passportNL,
  [COUNTRY_CODES.switzerland]: DOCUMENTS_TYPES.passportCH,
  [COUNTRY_CODES.thailand]: DOCUMENTS_TYPES.passportTH,
  [COUNTRY_CODES.usa]: DOCUMENTS_TYPES.passportUS,
  [COUNTRY_CODES.canada]: DOCUMENTS_TYPES.passportCA,
  [COUNTRY_CODES.japan]: DOCUMENTS_TYPES.passportJP,
  [COUNTRY_CODES.bulgaria]: DOCUMENTS_TYPES.passportBG,
  [COUNTRY_CODES.uae]: DOCUMENTS_TYPES.passportAE,
};

const DOC_TYPE_REMAPS: Array<{
  ocrCodes: Set<string>;
  // ICAO document class letters, used by SUBTYPED_DOC_CODE below.
  classLetters?: string[];
  byCountry: Record<string, CountryDocType>;
  fallback?: string;
}> = [
  {
    ocrCodes: IDENTITY_CARDS_OCR_CODES,
    classLetters: ['I', 'C'],
    byCountry: IDENTITY_CARD_BY_COUNTRY,
    fallback: DOCUMENTS_TYPES.identityCard,
  },
  {
    ocrCodes: RESIDENCE_PERMITS_OCR_CODES,
    byCountry: RESIDENCE_PERMIT_BY_COUNTRY,
  },
  {
    ocrCodes: DRIVING_LICENSES_OCR_CODES,
    byCountry: DRIVING_LICENSE_BY_COUNTRY,
    fallback: DOCUMENTS_TYPES.drivingLicense,
  },
  {
    ocrCodes: PASSPORTS_OCR_CODES,
    classLetters: ['P'],
    byCountry: PASSPORT_BY_COUNTRY,
    fallback: DOCUMENTS_TYPES.passport,
  },
];

// In an ICAO 9303 MRZ the first character is the document class and the second
// one is an optional subtype or the '<' filler. The subtype carries no meaning
// for us, so a two-character code we don't enumerate is resolved by its class
// letter alone: 'I*' and 'C*' are identity cards, 'P*' is a passport. Exact
// codes still win, which keeps 'IR'/'IM'/'IX' residence permits. 'A' is left
// out because this codebase uses 'AD'/'AR' for residence permits, and 'V'
// because no schema has a visa doc type.
const SUBTYPED_DOC_CODE = /^([A-Z])[A-Z0-9<]$/;

function findDocTypeRemap(docType: string) {
  const exactMatch = DOC_TYPE_REMAPS.find(({ocrCodes}) => ocrCodes.has(docType));
  if (exactMatch) {
    return exactMatch;
  }

  const classLetter = SUBTYPED_DOC_CODE.exec(docType)?.[1];
  if (!classLetter) {
    return undefined;
  }

  return DOC_TYPE_REMAPS.find(({classLetters}) => classLetters?.includes(classLetter));
}

function getRemappedDocType({
  docType,
  countryCode,
  nationality,
}: {
  docType?: string | null;
  countryCode?: string;
  nationality?: string;
}) {
  if (!docType) {
    return undefined;
  }

  const remap = findDocTypeRemap(docType);
  if (!remap) {
    return undefined;
  }

  const countryDocType = countryCode ? remap.byCountry[countryCode] : undefined;
  if (countryDocType === undefined) {
    return remap.fallback;
  }

  return typeof countryDocType === 'function'
    ? countryDocType(nationality)
    : countryDocType;
}

function getRemappedOfficialDocType({docType}: {docType?: string | null}) {
  if (docType && Object.values(DRIVING_LICENSES).includes(docType)) {
    return 'DL';
  }

  if (docType && Object.values(IDENTITY_CARDS).includes(docType)) {
    return 'ID';
  }
}

const dniValidation = [DNI_DOCUMENTS.dniES, DRIVING_LICENSES.drivingLicenseES];
const nieValidation = [DOCUMENTS_TYPES.spanishResidencePermitEU];

const PASSPORT_DOC_TYPES = new Set<string>(Object.values(PASSPORTS));
const DRIVING_LICENSE_DOC_TYPES = new Set<string>(Object.values(DRIVING_LICENSES));
const IDENTITY_CARD_DOC_TYPES = new Set<string>([
  ...Object.values(IDENTITY_CARDS),
  ...Object.values(DNI_DOCUMENTS),
]);

const isPassportDocType = (docType?: string | null) =>
  Boolean(docType) && PASSPORT_DOC_TYPES.has(docType as string);
const isDrivingLicenseDocType = (docType?: string | null) =>
  Boolean(docType) && DRIVING_LICENSE_DOC_TYPES.has(docType as string);
const isIdentityCardDocType = (docType?: string | null) =>
  Boolean(docType) && IDENTITY_CARD_DOC_TYPES.has(docType as string);

export {
  DOCUMENTS_TYPES,
  DRIVING_LICENSES,
  PASSPORTS,
  NO_EQUIVALENT_DOC_TYPE,
  getRemappedDocType,
  getRemappedOfficialDocType,
  dniValidation,
  nieValidation,
  isPassportDocType,
  isDrivingLicenseDocType,
  isIdentityCardDocType,
};
